export const INIT_ON_DEMAND_PARKING = 'INIT_ON_DEMAND_PARKING'
export const SET_ON_DEMAND_PARKING_BASELINE = 'SET_ON_DEMAND_PARKING_BASELINE'

export const SET_ON_DEMAND_ENABLED = 'SET_ON_DEMAND_ENABLED'
export const TOGGLE_ON_DEMAND_VEHICLE = 'TOGGLE_ON_DEMAND_VEHICLE'
export const SET_ON_DEMAND_CARD = 'SET_ON_DEMAND_CARD'

export const ACTIVATE_ON_DEMAND_REQUEST = 'ACTIVATE_ON_DEMAND_REQUEST'
export const SAVE_ON_DEMAND_CHANGES_REQUEST = 'SAVE_ON_DEMAND_CHANGES_REQUEST'
